import {publish} from "messaging/queue.js";
import {eq} from './compare.js';
import {doc} from './documentation.js';
import {switchOutput, s, cond, lazy, filter} from './lang.js';
import {tidal} from './tidal.js';
import {t_len} from './tlist.js';
import {t_cond} from './tidal.js';

doc(
    "triggerAttack",
    {
        "trackNumber": "",
        "transpose": "",
        "velocity": "",
    },
    "Triggers an attack (note on) for a given tracks instrument"
);
export const triggerAttack = (trackNumber, transpose, velocity=1) => {
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let subName = effect.track.subSequence.name.toLowerCase();
        let _trackNumber = lazy(trackNumber, ...args);
        let _velocity = lazy(velocity, ...args);
        let type = _trackNumber + subName + ".triggerAttack";
        if (stepData) {
            let _transpose = undefined;
            if (transpose === undefined) {
                _transpose = stepData.transpose;
            } else {
                _transpose = lazy(transpose, ... args);
            }
            publish(type, {trackNumber, time, transpose: _transpose, velocity: _velocity});
        }
        return filter(true);
    };
};

doc(
    "triggerRelease",
    {
        "trackNumber": "",
        "transpose": "",
    },
    "Triggers a release (note off) for a given tracks instrument"
);
export const triggerRelease = (trackNumber, transpose) => {
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let subName = effect.track.subSequence.name.toLowerCase();
        let type = trackNumber + subName + ".triggerRelease";
        if (stepData) {
            let _transpose = 0;
            if (transpose === undefined) {
                _transpose = stepData.transpose;
            }
            publish(type, {trackNumber, time, transpose: _transpose});
        }
        return filter(true);
    };
};

doc(
    "triggerAttackRelease",
    {
        "trackNumber": "",
    },
    "Triggers an attack release for a differennt track"
);
export const triggerAttackRelease = (trackNumber) => {
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let subName = effect.track.subSequence.name.toLowerCase();
        let _trackNumber = lazy(trackNumber, ...args);
        if (Array.isArray(_trackNumber)) {
            for (let _track of _trackNumber) {
                let type = _track+ subName + ".triggerAttackRelease";
                if (stepData && effect.track.trackNumber + 1 !== _track) {
                    publish(type, {trackNumber, time, stepData, stepNumber});
                }
            }
        } else {
            let type = _trackNumber + subName + ".triggerAttackRelease";
            if (stepData && _trackNumber !== effect.track.trackNumber + 1) {
                publish(type, {trackNumber, time, stepData, stepNumber});
            }
        }
        return filter(true);
    };
};

const current_track_number = () => {
    return (stepData, stepNumber, time, effect) => {
        return effect.track.trackNumber + 1;
    };
};

const isUndefined = (obj) => {
    return (... args) => {
        return filter(obj === undefined);
    };
};

export const t_trigger = (p, track, player=(pat) => tidal(pat, t_len(pat), 6, false), zObject) => s(
    player(p),
    cond(eq(current_track_number(), track),
         filter(true),
         s(
             cond(isUndefined(zObject),
                  s(
                      triggerAttackRelease(track),
                      filter(false)
                  ),
                  switchOutput(track))
         )));
